import { ICustomersAPIState } from "../types/customers.types";

export const CUSTOMERS_INITIAL_STATE: ICustomersAPIState = {
  data: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  selectedCustomerVehicles: {},
  selectedCustomerAttachments: {},
  list: [],
  loading: false,
  error: null,
  currentScreen: "list",
  selectedCustomer: null,
};
